/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ICONS from "../../../../../assets/Icons";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import {
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import { toast } from "react-toastify";
import CommonToast from "../../../../../components/_utils/CommonToast";

const ReimbursementContactSucess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];

  // Main title based on what was actually updated (sirf name update pe "Account name updated" dikhe)

  const { viewAccountDetailData, viewAccountDetailError } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const [isFocused, setIsFocused] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };
  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard", {
      replace: true,
    });
  };

  const approveAcc = async () => {
    UniversalRefreshToast("Approving account");
    try {
      toast.dismiss();

      const response = await dispatch(ReimburseApproveAccount(id)).unwrap();

      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
      if (response?.status) {
        CommonToast({
          text: "Account approved successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text:
            response?.payload?.errors?.reimbursement_account?.[0] ??
            "Something went wrong.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (err) {
      toast.dismiss();
    }
  };
  const rejectAcc = async ({ id, AccountIdData: accountIdData }) => {
    UniversalRefreshToast("Rejecting account");
    try {
      toast.dismiss();

      const response = await dispatch(
        ReimburseRejectAccount({ id, AccountIdData: accountIdData }),
      );
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
      if (response.status === true) {
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text:
            response?.payload?.errors?.reimbursement_account?.[0] ??
            "Something went wrong.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (err) {
      toast.dismiss();
    }
  };
  const NOT_AVAILABLE = "Not available";
  const NOT_LINKED = "Not linked";

  const beneficiaryAccount = viewAccountDetailData?.reimbursement_accounts?.[0];

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration.lengthCheckZero) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["account_name", "contact_no", "email_id", "linked_user"];

  const fieldConfig = {
    account_name: {
      getRows: (acc) => [
        {
          leftTitle: acc?.name ?? NOT_AVAILABLE,
          leftSubTitle: "Account name",
        },
      ],
    },

    contact_no: {
      getRows: (acc) => [
        {
          leftTitle: acc?.contact_no ? `+91 ${acc.contact_no}` : NOT_AVAILABLE,
          leftSubTitle: "Contact number",
          icon: ICONS?.CONTACT_WITH_WHITE_CIRCLE,
          iconSize: "small",
          bgNeeded: false,
        },
      ],
    },

    email_id: {
      getRows: (acc) => [
        {
          leftTitle: acc?.email_id || NOT_AVAILABLE,
          leftSubTitle: "Email ID",
          icon: ICONS?.CONTACT_US_MAIL,
          iconSize: "small",
          bgNeeded: false,
        },
      ],
    },

    linked_user: {
      getRows: (acc) => {
        const userName = acc?.reimbursement_user_full_name;
        const userId = acc?.reimbursement_identifier;

        const rows = [
          {
            leftTitle: userName || NOT_LINKED,
            leftSubTitle: "Username (optional)",
          },
        ];

        if (userName && userId) {
          rows.push({
            leftTitle: userId,
            leftSubTitle: "User ID",
          });
        }

        return rows;
      },
    },
  };

  const renderInfoCards = () =>
    fieldsToShow
      .filter((key) => fieldConfig[key])
      .map((key) => {
        const rows = fieldConfig[key].getRows(beneficiaryAccount);
        const hasMultipleRows = rows.length > 1;

        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={rows}
            {...(hasMultipleRows && {
              showRowDivider: true,
              rowBorderColor: "var(--positive-bg)",
            })}
          />
        );
      });

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };

  const buttonRows = [
    ...(services?.includes("RAAccount") || services?.includes("Admin")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                approveAcc();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),
    [
      // {
      //   btnText: "Create transaction",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS?.ADD_BUTTON_WHITE,
      //   handleFunction: createTxn,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  useEffect(() => {
    if (viewAccountDetailError) {
      navigate("*");
    }
  }, [viewAccountDetailError]);

  useEffect(() => {
    dispatch(viewAccountDetailR({ id }));
  }, [dispatch, id]);

  const AccountIdData = declineReason;

  return (
    <>
      <div>
        {rejectPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex">
            <div className="absolute top-top-base left-top-base h-full w-full opacity-dark-opacity bg-PopUp-BackDrop" />
            <SmallPopupWithInput
              headerTitle="Reject account"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              secondHeaderTitle="Provide the reason for rejection."
              secondHeaderFontWeight="normal"
              secondHeaderFontColor="text-secondary"
              secondHeaderTextSize="font-xs"
              noteColor="text-secondary"
              bulletPoints={[
                "New requests and transactions cannot be created for this account.",
                "Before rejecting this account, reject all associated transactions and requests.",
                "Users can edit the rejected account to update details.",
              ]}
              subtextwithbullet="Y"
              inputPlaceholder={"Reason"}
              inputVariant={computeVariant(declineReason, isFocused)}
              inputOnFocus={(e) => setIsFocused(true)}
              inputOnBlur={(e) => setIsFocused(false)}
              btnOneIsDisabled={showLoader ? true : false}
              inputBgColor="var(--primary-bg)"
              noteText="Minimum 10 characters required."
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="big"
              inputIsFullWidth={true}
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                setRejectPopup(false);
                setDeclineReason("");
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                setShowLoader(true);
                rejectAcc({ id, AccountIdData });
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                declineReason.trim().length <
                GlobalConfiguration.rejectReasonMinLength
              }
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoHoverOption="black"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        )}{" "}
        <StatusContainer
          status="success"
          hoverOption="black"
          buttonRows={buttonRows}
          title={"Account details updated successfully."}
        >
          <TabsWeapperSection title="Updated details">
            <>{renderInfoCards()}</>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default ReimbursementContactSucess;
